import { APP_PERMISSIONS } from '@exam-center/permission';
import { ProctoringEKycList, ProctoringEKycSearchBox } from '@exam-center/proctoring-ekyc-list';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function EKycPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTORING.E_KYC.VIEW}>
      <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'auto' }}>
        <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
          <PaperSection
            title='ตรวจสอบการยืนยันตัวตน (e-KYC)'
            sx={{
              width: '100%',
              flexDirection: 'column',
              height: 'fit-content',
            }}
          >
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                gap: theme.spacing(4),
                pt: theme.spacing(6),
              })}
            >
              <ProctoringEKycSearchBox />
              <ProctoringEKycList />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
